<div class="duna-catering-groups-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Forplejningsgrupper</h1></mat-card-title>
      <mat-card-subtitle>
        Opret grupper og tilføj forplejningsansvarlige. Grupper tilknyttes events under forplejningsønsker.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  <mat-card class="table-card">
    <div class="card-header-with-action">
      <div class="card-header-text">
        <span class="card-title">Grupper</span>
        <span class="card-subtitle">Organisationens forplejningsgrupper</span>
      </div>
      <button mat-raised-button color="primary" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        Opret gruppe
      </button>
    </div>
    <mat-card-content>
      @if (errorMessage) {
        <div class="state state-error">{{ errorMessage }}</div>
      }
      @if (loading) {
        <div class="state">Henter grupper…</div>
      } @else {
        <table mat-table [dataSource]="groupsDataSource" class="groups-table">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Navn</th>
            <td mat-cell *matCellDef="let row">{{ row.name }}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Beskrivelse</th>
            <td mat-cell *matCellDef="let row">{{ row.description || '–' }}</td>
          </ng-container>

          <ng-container matColumnDef="member_count">
            <th mat-header-cell *matHeaderCellDef>Ansvarlige</th>
            <td mat-cell *matCellDef="let row">{{ row.member_count ?? 0 }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-stroked-button color="primary" (click)="openMembersDialog(row)">
                Administrer
              </button>
              <button mat-stroked-button (click)="openEditDialog(row)">Rediger</button>
              <button mat-stroked-button color="warn" class="delete-btn" (click)="deleteGroup(row)">Slet</button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="displayedColumns.length">Ingen forplejningsgrupper oprettet endnu.</td>
          </tr>
        </table>
      }
    </mat-card-content>
  </mat-card>
</div>
